import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const withFreezeTableResize = (Component) => {
  const WrappedComponent = (props) => {
    const { top: scrollTopDefault, width } = props;
    const [scrollTop, setScrollTop] = useState(scrollTopDefault);
    const [widthContainer, setWidthContainer] = useState(width);

    // Register observers once; previous version re-created them on every
    // scrollTop/width change and never disconnected, which could freeze the UI.
    useEffect(() => {
      const topbarEL = document.getElementById('top-bar');
      const commonBarEl = document.getElementById('common-bar');
      const paginationTableEl = document.getElementById('pagination-table');
      const mainContentEl = document.getElementById('main-content');
      const freezeTableEL = document.getElementsByClassName('freeze-table')[0];
      const priorityAxisBarEL = document.getElementById('priority-axis-bar');
      const freezeHeadAreaEl = document.getElementById('freeze-head-area');
      const cookieProgramEL = document.getElementsByClassName(
        'cookie-program'
      )[0];

      if (
        !mainContentEl ||
        !paginationTableEl ||
        !topbarEL ||
        !commonBarEl ||
        !freezeTableEL
      ) {
        return undefined;
      }

      const freezeHeadAreaElHeight =
        freezeHeadAreaEl !== null && cookieProgramEL !== null
          ? freezeHeadAreaEl.getBoundingClientRect().height
          : 0;

      const priorityAxisBarHeight = priorityAxisBarEL
        ? priorityAxisBarEL.getBoundingClientRect().height
        : 0;

      const offsetHeight = paginationTableEl.getBoundingClientRect().height;
      let defaultTop =
        topbarEL.getBoundingClientRect().height +
        offsetHeight +
        priorityAxisBarHeight;

      if (freezeHeadAreaEl !== null && cookieProgramEL !== null) {
        defaultTop += freezeHeadAreaElHeight;
      }

      const updateScrollTop = () => {
        const commonBarElHeight = commonBarEl.getBoundingClientRect().height;
        const nextTop = defaultTop + commonBarElHeight;
        setScrollTop((prev) => (prev !== nextTop ? nextTop : prev));
      };

      updateScrollTop();

      const widthObserver = new ResizeObserver((entries) => {
        window.requestAnimationFrame(() => {
          if (!Array.isArray(entries) || !entries.length) return;
          const nextWidth = mainContentEl.offsetWidth;
          setWidthContainer((prev) => (prev !== nextWidth ? nextWidth : prev));
        });
      });

      const heightObserver = new ResizeObserver(() => {
        window.requestAnimationFrame(updateScrollTop);
      });

      heightObserver.observe(commonBarEl);
      widthObserver.observe(freezeTableEL);

      return () => {
        heightObserver.disconnect();
        widthObserver.disconnect();
      };
    }, []);

    useEffect(() => {
      const paginationTableEl = document.getElementById('pagination-table');
      const priorityAxisBarEL = document.getElementById('priority-axis-bar');
      if (!paginationTableEl) return undefined;

      const offsetHeight = paginationTableEl.getBoundingClientRect().height;
      const topValue = scrollTop - offsetHeight;
      if (Number.isFinite(topValue)) {
        Object.assign(paginationTableEl.style, {
          top: `${topValue}px`,
        });
      }

      if (priorityAxisBarEL) {
        const priorityTop =
          scrollTop -
          offsetHeight -
          priorityAxisBarEL.getBoundingClientRect().height;
        if (Number.isFinite(priorityTop)) {
          Object.assign(priorityAxisBarEL.style, {
            top: `${priorityTop}px`,
          });
        }
      }

      return undefined;
    }, [scrollTop]);

    // eslint-disable-next-line react/jsx-props-no-spreading
    return <Component {...props} top={scrollTop} width={widthContainer} />;
  };

  WrappedComponent.propTypes = {
    top: PropTypes.number,
    width: PropTypes.number,
  };

  WrappedComponent.defaultProps = {
    top: 0,
    width: 0,
  };

  return WrappedComponent;
};

export default withFreezeTableResize;
